import {Component, inject, OnInit} from '@angular/core'
import {Router} from '@angular/router'
import {BankIdComponent} from '@samtycke/samtycke-bankid-fe'
import {environment} from '../../../environments/environment'
import {ENVIRONMENT} from '../../0-general/providers'
import {HOME_PATH} from '../../0-general/shared'
import {ConfigService} from '../../services/config.service'
import {filter, take} from 'rxjs'


@Component({
  selector: 'smt-login',
  imports: [
    BankIdComponent
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  providers: [
    {provide: ENVIRONMENT, useValue: environment}
  ]
})
export class LoginComponent implements OnInit {
  protected readonly environment = inject(ENVIRONMENT)

  public readonly service = inject(ConfigService)

  private readonly router = inject(Router)

  public ngOnInit(): void {
    this.service.accessToken$
      .pipe(
        filter(Boolean),
        take(1)
      )
      .subscribe(() => this.router.navigate(['/', HOME_PATH]))
  }
}
